import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=679bd3ef&scoped=true&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"
import style0 from "./Detail.vue?vue&type=style&index=0&id=679bd3ef&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./Detail.vue?vue&type=style&index=1&id=679bd3ef&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679bd3ef",
  null
  
)

export default component.exports